import styled from 'styled-components';

import { OnboardingPage } from '../../components/Page';

export const LayoutStyles = styled(OnboardingPage)`
  ion-content {
    &::part(scroll) {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 16px;
      height: 100%;
      padding: 20px;
    }

    .form-devsub {
      display: flex;
      flex-direction: column;
      gap: 16px;

      input[type='text'] {
        width: 100%;
        padding: 4px 12px;
        border-radius: 8px;
        border: 1px solid var(--border-color-light);
        outline: none;
        background: var(--background-color-light);
        color: var(--text-color-black);

        &:focus {
          border-color: var(--border-color-primary);
        }
      }

      fieldset {
        border: none;
        padding: 0;
        margin: 16px 0;
      }
    }
  }
`;
